import * as React from "react";

function DeleteIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M3.68416 10.3335H30.3508V32.0002C30.3508 32.4422 30.1752 32.8661 29.8627 33.1787C29.5501 33.4912 29.1262 33.6668 28.6842 33.6668H5.35083C4.9088 33.6668 4.48488 33.4912 4.17232 33.1787C3.85976 32.8661 3.68416 32.4422 3.68416 32.0002V10.3335ZM7.0175 13.6668V30.3335H27.0175V13.6668H7.0175ZM12.0175 17.0002H15.3508V27.0002H12.0175V17.0002ZM18.6842 17.0002H22.0175V27.0002H18.6842V17.0002ZM8.68416 5.3335V2.00016C8.68416 1.55814 8.85976 1.13421 9.17232 0.821651C9.48488 0.509091 9.9088 0.333496 10.3508 0.333496H23.6842C24.1262 0.333496 24.5501 0.509091 24.8627 0.821651C25.1752 1.13421 25.3508 1.55814 25.3508 2.00016V5.3335H33.6842V8.66683H0.35083V5.3335H8.68416ZM12.0175 3.66683V5.3335H22.0175V3.66683H12.0175Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoDeleteIcon = React.memo(DeleteIcon);
export default MemoDeleteIcon;
